import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

// App Check activates only when the reCAPTCHA v3 site key is configured
if (process.env.REACT_APP_RECAPTCHA_SITE_KEY) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const fbAuth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

const FB_ERRORS = {
  "auth/email-already-in-use": "An account with this email already exists — try logging in instead",
  "auth/invalid-credential": "Incorrect email or password — check and try again",
  "auth/wrong-password": "Incorrect email or password — check and try again",
  "auth/user-not-found": "No account found with this email — create one first",
  "auth/weak-password": "Password is too weak — use at least 6 characters",
  "auth/too-many-requests": "Too many attempts. Please wait 15–60 minutes and try again.",
  "auth/popup-blocked": "Your browser blocked the sign-in popup — allow popups for this site and try again",
  "auth/popup-closed-by-user": "The sign-in popup was closed before finishing",
  "auth/cancelled-popup-request": "The sign-in popup was closed before finishing",
  "auth/unauthorized-domain": "This domain isn't authorised for sign-in yet — add it in Firebase Console → Authentication → Settings → Authorized domains",
  "auth/invalid-phone-number": "Enter a valid mobile number, e.g. +91 98765 43210",
  "auth/invalid-verification-code": "That OTP doesn't match — check the 6 digits and try again",
  "auth/code-expired": "The OTP expired — request a new one",
  "auth/credential-already-in-use": "This mobile number is already linked to another account",
  "auth/account-exists-with-different-credential": "This email uses a different sign-in method — try Continue with Google",
  "auth/network-request-failed": "Network hiccup — check your connection and retry",
};

export const fbError = (e) =>
  FB_ERRORS[e?.code] || (e?.message || "").replace("Firebase: ", "").replace(/\(auth\/.*\)\.?/, "").trim() || "Something went wrong — try again";
